import React, { useState } from 'react';

import { generalMessages } from '../../../../../translates/generalMessages';
import { trackingMessages } from '../../../../../translates/trackingMessages';
import { OverlayConfirmation } from '../../../../components/shared/OverlayConfirmation';
import { useIntlReexport } from '../../../../hooks/useIntlReexport';
import { AdminLayout, Button, ButtonVariant, SettingsMenuItem } from '@ael/shared-components-library';
import { FormattedMessage } from 'react-intl';

import './SettingsMenu.scss';

export type SettingsMenuDispatchProps = {
  resetProgressAndCloseSidebar: () => void;
};

export const SettingsMenu: React.FunctionComponent<SettingsMenuDispatchProps> = ({ resetProgressAndCloseSidebar }) => {
  const [showResetConfirmation, setShowResetConfirmation] = useState(false);
  const { formatMessage } = useIntlReexport();

  const showConfirmation = () => setShowResetConfirmation(true);
  const closeConfirmation = () => setShowResetConfirmation(false);
  const handleResetConfirm = () => {
    resetProgressAndCloseSidebar();
    closeConfirmation();
  };

  return (
    <>
      <AdminLayout.Header.Title>
        <FormattedMessage {...generalMessages.settings} />
      </AdminLayout.Header.Title>
      <div className="student-settings-menu">
        <SettingsMenuItem
          title={formatMessage(trackingMessages.resetProgressTitle)}
          description={formatMessage(trackingMessages.resetProgressDescription)}
          ActionComponent={
            <Button onClick={showConfirmation} variant={ButtonVariant.PRIMARY}>
              {formatMessage(trackingMessages.resetProgressTitle)}
            </Button>
          }
        />
        {showResetConfirmation && (
          <OverlayConfirmation
            header={formatMessage(trackingMessages.resetProgressTitle)}
            text={formatMessage(trackingMessages.resetProgressConfirmText)}
            buttonLabel={formatMessage(generalMessages.reset)}
            onCancel={closeConfirmation}
            onClick={handleResetConfirm}
          />
        )}
      </div>
    </>
  );
};
